import { activeOnboarding } from '../activeOnboarding';
import type { SupportedFeatureIds } from '../types';
import type { SupportedNudgeFeatureIds } from '../nudges/types';
import { NUDGE_FEATURE_ID_MAP } from '../nudges/types';
import { isOnboardingFeatureId } from './typeHelpers';
import { isNudgeFeatureId } from '../nudges/utils/typeHelpers';

export const getUniqueFeatureId = (id: SupportedFeatureIds | SupportedNudgeFeatureIds): string => {
  if (isOnboardingFeatureId(id)) {
    return activeOnboarding[id].id;
  }

  if (isNudgeFeatureId(id)) {
    return NUDGE_FEATURE_ID_MAP[id];
  }

  return id;
};
